import languages from './languages.json';
export const DEFAULT_LANGUAGE = 'en';
export const LANGUAGE_OPTIONS = languages.map(({ code, label }) => ({
  value: code,
  label
}));
const matchLanguage = (input?: string | null): string | undefined => {
  const normalized = String(input || '')
    .trim()
    .replace(/_/g, '-')
    .toLowerCase();
  return (
    languages.find(({ code }) => code.toLowerCase() === normalized)?.code ||
    languages.find(({ code }) => code === normalized.split('-')[0])?.code
  );
};
export const resolveLanguage = (input?: string | null): string =>
  matchLanguage(input) || DEFAULT_LANGUAGE;

export const resolvePreferredLanguage = (
  preferences: readonly string[]
): string => {
  for (const preference of preferences) {
    const match = matchLanguage(preference);
    if (match) return match;
  }
  return DEFAULT_LANGUAGE;
};

export const languageDirection = (code: string) =>
  languages.find((item) => item.code === code)?.direction || 'ltr';
